import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { logClientError } from '@/lib/error-log';
import i18n from '@/i18n';

interface State {
  hasError: boolean;
  message: string;
}

/**
 * Ilovada kutilmagan xato bo'lsa oq ekran o'rniga tushunarli xabar ko'rsatadi.
 * Savatcha localStorage'da saqlanadi, shuning uchun sahifani qayta yuklash xavfsiz.
 */
export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error?.message ?? i18n.t('misc_error.unknown') };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logClientError(error.message, `${error.stack ?? ''}\n${info.componentStack ?? ''}`);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-6">
        <div className="w-full max-w-md rounded-xl border border-border bg-card p-6 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
            <AlertTriangle className="text-destructive" size={22} />
          </div>
          <h1 className="text-lg font-semibold text-foreground">{i18n.t('misc_error.title')}</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            {i18n.t('misc_error.body')}
          </p>
          <p className="mt-3 break-words rounded-lg bg-muted p-2 text-xs font-mono text-muted-foreground">
            {this.state.message}
          </p>
          <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:justify-center">
            <Button onClick={() => window.location.reload()} className="gap-2">
              <RefreshCw size={16} /> {i18n.t('misc_error.reload')}
            </Button>
            <Button variant="outline" onClick={() => { window.location.href = '/pos'; }}>
              {i18n.t('misc_error.back_pos')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
